// extracted by mini-css-extract-plugin
export default {"mode":"style_mode__VJw7C","light":"style_light__7mHbT","dark":"style_dark__cw7zX","ratioLeft":"style_ratioLeft__6lINa","ratioRight":"style_ratioRight__sJglh"};